// import Button from 'components/shared/Button/Button';
// import Icon from 'components/shared/Icon/Icon';

// const GoLiveDateBanner = ({ navigateToSubstep = () => {} }) => {
const GoLiveDateBanner = () => {
  return null;
  // return (
  //   <div className="absolute -top-12 left-0 h-12 w-full bg-danger-50">
  //     <div className="ml-auto mr-auto flex max-w-[768px] items-center justify-center gap-3">
  //       <Icon icon="info-circle-filled" color="danger" size={18} className="flex-shrink-0" />
  //       <span className="flex-shrink-0 text-sm">
  //         You must confirm your Go-live dates before acknowledging Terms & conditions.
  //       </span>
  //       <Button
  //         text="Go to Go-live dates step"
  //         className="text-nowrap text-xs font-500 text-black underline"
  //         variant="link"
  //         onClick={() =>
  //           navigateToSubstep('onboarding__go_live_dates_and_trainings__go_live_dates')
  //         }
  //       />
  //     </div>
  //   </div>
  // );
};

export default GoLiveDateBanner;
